import React from 'react';
import { Gerenciar } from './Gerenciar';
import { VerMapa } from './VerMapa';
import { useApp } from '../../../../context/app';

export const SalaEmpreendedor = () => {
  const { renderIncludeScreen } = useApp();

  return renderIncludeScreen ?  <VerMapa />  :  <Gerenciar />;
};
